import _defineProperty from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import audio from './audio';
import routeParamConstants from './routeParamConstants';
import QueryParamsProxy from './queryParamProxy';
var showModal = function showModal(modalType) {
  audio.onClick();
  QueryParamsProxy.setQueryParams(_defineProperty({}, routeParamConstants.PARAM_MODAL, modalType));
};
export default showModal;